import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Splide from '@splidejs/splide';

Alpine.plugin(collapse);
Alpine.start();


document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.splide');
  if (slider != null) {
    const splide = new Splide('.splide', {
      classes: {
        arrows: 'splide__arrows slide-arrows',
        arrow: 'splide__arrow slide-arrow',
      }
    }).mount();

    SlideNumber(splide);
  }
});

function SlideNumber(Splide) {
  let paginationElement = null;

  Splide.on('mounted resize', () => update(Splide));
  Splide.on('move', () => update(Splide));

  function update(Splide) {
    const { Elements } = Splide.Components;
    const track = Elements.track;

    if (!paginationElement) {
      paginationElement = document.createElement('div');
      paginationElement.classList.add('splide__slide__number');
      track.parentElement.appendChild(paginationElement);
    }

    paginationElement.textContent = `${Splide.index + 1}/${Splide.length}`;
  }
}